var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment"},[_c('p',{staticClass:"comment-user"},[_vm._v(_vm._s(_vm.comment.user))]),_c('p',{staticClass:"comment-body"},[_vm._v(_vm._s(_vm.comment.body))])])}
var staticRenderFns = []

export { render, staticRenderFns }